<template>
  <div class="root">
    <div class="banner">
      <img class="logo" :src="logo" />
      <span class="text">{{projectName}}</span>
    </div>
    <div class="profile">
      <el-dropdown @command="onClickProfileDropdownMenuItem">
        <span class="username">
            {{ getLoginUsername() }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          <!--<el-dropdown-item command="changePassword">修改密码</el-dropdown-item>-->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
const util = require("@/util");
import store from "@/store";

export default {
  data() {
    return {
      projectName: "", // 项目名称
      logo: "", // logo的路径
    }
  },

  created() {
    // 取得项目名称
    this.projectName = store.projectInfo.name;

    // 取得logo的路径
    this.logo = util.getBackendApiBase() + store.projectInfo.logo;
  },

  methods: {
    /**
     * 
     * @param {*} command 
     */
    onClickProfileDropdownMenuItem(command) {
        switch (command) {
            case "logout": {
                this.onClickLogoutBtn();
                break;
            }
            case "changePassword": {
                this.onClickChangePasswordBtn();
                break;
            }
        }
    },

    /**
     * 点击了“退出登录”按钮
     */
    onClickLogoutBtn() {
      util.removeFromLocalStorage("loginUser");
      util.gotoLoginPage();
    },

    /**
     * 点击了“修改密码”按钮
     */
     onClickChangePasswordBtn() {
        this.$message({
          message: "暂未实现",
          type: "info",
        });
    },

    /**
     * 取得当前登录用户的用户名
     */
    getLoginUsername() {
      let loginUser = util.getFromLocalStorage("loginUser");
      if (loginUser) {
        return loginUser.username;
      } else {
        return "";
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.root {
  height: 60px;
  width: 100%;
  position: fixed;
  background-color: #1a73e8;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.banner {
  position: relative;
  left: 8px;
  height: 70%;
  display: flex;
  align-items: center;
}

.banner .logo {
  height: 100%;
}

.banner .text {
  font-weight: bold;
  font-size: 1.4rem;
  color: white;
  margin-left: 8px;
}

.profile {
  position: relative;
  right: 10px;
  display: flex;
  justify-content: right;
  align-items: center;
  cursor: pointer;
}

.profile .username {
  color: white;
  font-size: 1.1rem;
}

</style>